import { Component, Input, OnInit, output } from '@angular/core';
import { ControlContainer, UntypedFormArray, UntypedFormControl, UntypedFormGroup, FormGroupDirective } from '@angular/forms';
import { TypZaznamuTextu } from '../model/typ-zaznamu-textu';
import { ErrorDialogComponent } from 'projects/ais-common/src/public-api';
import { MatDialog } from '@angular/material/dialog';
import { AppStateService } from '../app-state.service';
import { FormService } from '../form.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-date-typ',
    templateUrl: './date-typ.component.html',
    styleUrls: ['./date-typ.component.css'],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective
        }
    ],
    standalone: false
})
export class DateTypComponent implements OnInit {

  @Input() kodJazykIN: string;
  @Input() typZaznamuTextu: TypZaznamuTextu;
  @Input() indexPolozkyVoFormulari: number;

  value = 'Clear me';

  @Input() formularFormGroup: UntypedFormGroup;
  formArrayJazyk1: UntypedFormArray = new UntypedFormArray([]);
  formArrayJazyk2: UntypedFormArray = new UntypedFormArray([]);
  formArrayJazyk3: UntypedFormArray = new UntypedFormArray([]);

  jazykyFormularaPole: string[] = [];
  jazykFormulara1: string = 'SK';
  jazykFormulara2: string = '';
  jazykFormulara3: string = '';
  existujeVoFormulariJazyk2 = false;
  existujeVoFormulariJazyk3 = false;

  mapaJazykovAFormArrays: Map<string, UntypedFormArray> = new Map();
  jeOpakovaniePodprogramu: boolean;

  pocetPoloziekJazyk1: number = 0;
  pocetPoloziekJazyk2: number = 0;
  pocetPoloziekJazyk3: number = 0;

  pocetPridanychPoloziekJazyk1: number = 0;
  pocetPridanychPoloziekJazyk2: number = 0;
  pocetPridanychPoloziekJazyk3: number = 0;

  zobrazitHelpTextSK = false;
  zobrazitHelpTextEN = false;

  datumZmenenyManualne = output<void>();

  constructor(public dialog: MatDialog,
    public appStateService: AppStateService,
    public formService: FormService,
    private translateService: TranslateService) { }

  ngOnInit(): void {

    this.jazykyFormularaPole = this.appStateService.jazykyFormulara;
    this.jazykFormulara1 = this.jazykyFormularaPole[0];
    if (this.jazykyFormularaPole.length >= 2) {
      this.jazykFormulara2 = this.jazykyFormularaPole[1];
      this.existujeVoFormulariJazyk2 = true;
    }
    if (this.jazykyFormularaPole.length >= 3) {
      this.jazykFormulara3 = this.jazykyFormularaPole[2];
      this.existujeVoFormulariJazyk3 = true;
    }

    this.jeOpakovaniePodprogramu = this.appStateService.jeOpakovaniePodprogramu(this.typZaznamuTextu);

    if (this.typZaznamuTextu.opakovanie === 'A' || this.jeOpakovaniePodprogramu) {

      const menoArrayControlsu: string = 'name_' + this.typZaznamuTextu.id + '_' + this.jazykFormulara1;
      this.formArrayJazyk1 = <UntypedFormArray>this.formularFormGroup.get(menoArrayControlsu);
      this.pocetPoloziekJazyk1 = this.formArrayJazyk1.length;
      // pocet pridanych poloziek oproti minimu (minPocet)
      this.pocetPridanychPoloziekJazyk1 = this.formArrayJazyk1.length - this.typZaznamuTextu.minPocet;

      if (this.existujeVoFormulariJazyk2) {
        const menoArrayControlsuJazyk2: string = 'name_' + this.typZaznamuTextu.id + '_' + this.jazykFormulara2;
        this.formArrayJazyk2 = <UntypedFormArray>this.formularFormGroup.get(menoArrayControlsuJazyk2);
        this.pocetPoloziekJazyk2 = this.formArrayJazyk2.length;
        // pocet pridanych poloziek oproti minimu (minPocet)
        this.pocetPridanychPoloziekJazyk2 = this.formArrayJazyk2.length - this.typZaznamuTextu.minPocet;
      }

      if (this.existujeVoFormulariJazyk3) {
        const menoArrayControlsuJazyk3: string = 'name_' + this.typZaznamuTextu.id + '_' + this.jazykFormulara3;
        this.formArrayJazyk3 = <UntypedFormArray>this.formularFormGroup.get(menoArrayControlsuJazyk3);
        this.pocetPoloziekJazyk3 = this.formArrayJazyk3.length;
        // pocet pridanych poloziek oproti minimu (minPocet)
        this.pocetPridanychPoloziekJazyk3 = this.formArrayJazyk3.length - this.typZaznamuTextu.minPocet;
      }

    }

    this.mapaJazykovAFormArrays.set(this.jazykyFormularaPole[0], this.formArrayJazyk1);
    if (this.jazykyFormularaPole.length >= 2) {
      this.mapaJazykovAFormArrays.set(this.jazykyFormularaPole[1], this.formArrayJazyk2);
    }
    if (this.jazykyFormularaPole.length >= 3) {
      this.mapaJazykovAFormArrays.set(this.jazykyFormularaPole[2], this.formArrayJazyk3);
    }

  }

  pridatOpakovanuPolozku(jazyk: string){
    if (!(this.typZaznamuTextu.podprogram === 1)) {
      this.pocetPoloziekJazyk1 = this.formArrayJazyk1.length;
      this.pocetPoloziekJazyk2 = this.formArrayJazyk2.length;
      this.pocetPoloziekJazyk3 = this.formArrayJazyk3.length;
      const text = this.translateService.instant('Už je pridaný maximálny povolený počet položiek.');
      if (jazyk === this.jazykFormulara1) {
        if (this.pocetPoloziekJazyk1 >= this.typZaznamuTextu.maxPocet) {
          this.openErrorDialog(text);
          return;
        }
      } else if (jazyk === this.jazykFormulara2) {
        if (this.pocetPoloziekJazyk2 >= this.typZaznamuTextu.maxPocet) {
          this.openErrorDialog(text);
          return;
        }
      } else if (this.jazykyFormularaPole.length >= 3 && jazyk === this.jazykFormulara3) {
        if (this.pocetPoloziekJazyk3 >= this.typZaznamuTextu.maxPocet) {
          this.openErrorDialog(text);
          return;
        }
      }
    }

    const name = 'name_' + this.typZaznamuTextu.id + '_' + jazyk;
    const control = new UntypedFormControl('');
    (<UntypedFormArray>this.formularFormGroup.get(name)).push(control);

    if (jazyk === this.jazykFormulara1) {
      this.pocetPoloziekJazyk1++;
      this.pocetPridanychPoloziekJazyk1++;
    } else if (jazyk === this.jazykFormulara2) {
      this.pocetPoloziekJazyk2++;
      this.pocetPridanychPoloziekJazyk2++;
    } else if (this.jazykyFormularaPole.length >= 3 && jazyk === this.jazykFormulara3) {
      this.pocetPoloziekJazyk3++;
      this.pocetPridanychPoloziekJazyk3++;
    }


    // console.log('this.formArraySK: ' + this.formArrayJazyk1.length);
    // console.log('this.pocetPoloziekSK: ' + this.pocetPoloziekJazyk1);
    // console.log('this.pocetPridanychPoloziekSK: ' + this.pocetPridanychPoloziekJazyk1);
  }



  vymazObsahPolozky(jazyk: string, index? : number) {
    this.appStateService.vymazObsahPolozkyFormulara(this.formularFormGroup,
      this.typZaznamuTextu, jazyk, index)
  }

  openErrorDialog(msg: string) {
    this.dialog.open(ErrorDialogComponent, {
      panelClass: 'alert-danger',
        data: {message: msg},
        width: '500px',
      });
  }

  getPridatPolozkuTooltip() {
    let result = this.translateService.instant('Pridať položku') +  ' ('
      + this.translateService.instant('max. počet je') + ') ' + this.typZaznamuTextu.maxPocet + ')';
    if (this.typZaznamuTextu.opakovanie !== 'A' && this.typZaznamuTextu.podprogram === 1) {
      result = this.translateService.instant('Pridať položku');
    }

    return result;
  }

  // getSpolocnaPolozkaText(index: number): string {
  //   let result = '';

  //   if (this.appStateService.mapaIdTypovAMapJazykovAZaznamovsPodprogramami.get(typZaznamu.id)) {
  //     const zaznamy = this.appStateService.mapaIdTypovAMapJazykovAZaznamovsPodprogramami.get(typZaznamu.id).get(kodJazyk);
  //     if (zaznamy && zaznamy.length > index) {
  //       result = 'Spoločná položka podprogramu ' +
  //         zaznamy[index].podprogram;
  //     }
  //   }

  //   return result;
  // }

  // indexDruhejPolozky - index druhej polozky z tych dvoch poloziek, ktore medzi sebou vymienam
  vymenPolozky(indexDruhejPolozky: number, kodJazyk: string) {

    this.formService.vymenPolozky(this.formularFormGroup,
      this.typZaznamuTextu, indexDruhejPolozky, kodJazyk)

  }

  getVymenitObsahPoloziekTooltip() {
    return this.translateService.instant('Vymeniť obsah položiek');
  }

  getZmazatTooltip() {
    return this.translateService.instant("Zmazať");
  }

  onInputManualChange() {
    // Dáme rodičovi vedieť, že používateľ ručne písal do inputu
    this.datumZmenenyManualne.emit();
  }


}
